// @flow
// What the browser has natively, read before core-js fills the gaps on the page: app/index.js imports this
// module first, before 'core-js'. Code that runs outside the page, like pdf.js's Web Worker, gets only these.
export const nativeBuiltIns = {
  // Chrome 92, Safari 15.4, Firefox 90
  arrayAt: typeof (Array.prototype: any).at === 'function',
};
